import LeonMessage from './LeonMessage'
import LeonSignOut from './LeonSignOut'
import LeonAlert from './LeonAlert'
import LeonPopup from './LeonPopup'
import LeonSimpleLogin from './LeonSimpleLogin'
import LeonNoPublic from './LeonNoPublic'
import IntegralMask from './IntegralMask'

const install = (Vue) => {
  Vue.component(LeonMessage.name, LeonMessage)                 // 消息提示框
  Vue.component(LeonSignOut.name, LeonSignOut)                 // 登出提示
  Vue.component(LeonAlert.name, LeonAlert)                     // alert弹框
  Vue.component(LeonPopup.name, LeonPopup)                     // 从下部弹出的部分弹框
  Vue.component(LeonSimpleLogin.name, LeonSimpleLogin)         // 简易版登录
  Vue.component(LeonNoPublic.name, LeonNoPublic)               // 微信公众号组件
  Vue.component(IntegralMask.name, IntegralMask)       // 积分

  Vue.prototype.$_message = LeonMessage.installMessage
  Vue.prototype.$_alert = LeonAlert.installAlert
  Vue.prototype.$_signOut = LeonSignOut.installSignOut
  Vue.prototype.$_simpleLogin = LeonSimpleLogin.install     // 简易版登录弹框
  Vue.prototype.$_IntegralMask = IntegralMask.install            // 积分弹框
}
export default install



// WEBPACK FOOTER //
// ./src/plugin/index.js